import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal as RNModal, Platform, TouchableWithoutFeedback } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useTheme } from '../context/ThemeContext';

const Modal = ({ visible, onClose, title, children, showCloseButton = true, backgroundColor = null, fullScreen = false, maxWidth = 1200, minWidth = 400, minHeight = null }) => {
  const { palette, mode } = useTheme();

  if (!visible) return null;

  return (
    <RNModal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={[styles.overlay, { padding: fullScreen ? 0 : 20 }]}>
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.backdrop} />
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback>
          <View style={[styles.modalContainer, fullScreen ? styles.fullScreen : {}]}>
          <View style={[
            styles.modalContent,
            fullScreen && { height: '100%' },
            {
              borderRadius: fullScreen ? 0 : 16,
              maxHeight: fullScreen ? '100%' : '90%',
              maxWidth: maxWidth,
              minWidth: minWidth,
              minHeight: minHeight,
              backgroundColor: backgroundColor || (mode === 'dark' 
                ? 'rgba(23, 23, 23, 0.50)' 
                : 'rgba(255, 255, 255, 0.50)'),
              borderColor: fullScreen ? 'transparent' : backgroundColor ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.18)',
            },
          ]}>
          {title && (
            <View style={styles.header}>
              <Text style={[styles.title, { color: palette.text || 'white' }]}>{title}</Text>
              {showCloseButton && (
                <TouchableOpacity
                  onPress={onClose}
                  style={[styles.closeButton, { borderColor: palette.border || 'rgba(255,255,255,0.16)' }]}
                >
                  <MaterialCommunityIcons name="close" size={20} color={palette.text || 'white'} />
                </TouchableOpacity>
              )}
            </View>
          )}
          {!title && showCloseButton && (
            <TouchableOpacity
              onPress={onClose}
              style={styles.closeButtonAbsolute}
            >
              <MaterialCommunityIcons name="close" size={20} color="#000000" />
            </TouchableOpacity>
          )}
          <View style={styles.content}>
            {children}
          </View>
          </View>
        </View>
        </TouchableWithoutFeedback>
      </View>
    </RNModal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  modalContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '95%',
    maxHeight: '95%',
    zIndex: 1,
  },
  fullScreen: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  modalContent: {
    width: '100%',
    minWidth: 400,
    maxWidth: 1200,
    borderRadius: 16,
    borderWidth: 4,
    padding: 24,
    ...Platform.select({
      web: {
        maxHeight: '90vh',
        boxShadow: '8px 10px 0px rgba(0,0,0,0.9)',
      },
      default: {
        shadowColor: '#000',
        shadowOffset: { width: 8, height: 10 },
        shadowOpacity: 0.9,
        shadowRadius: 0,
        elevation: 10,
      },
    }),
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    gap: 16,
  },
  title: {
    fontSize: 20,
    fontFamily: 'Sen',
    fontWeight: '700',
    lineHeight: 28,
    width: '100%',
    textAlign: 'center',
    flex: 1,
  },
  closeButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButtonAbsolute: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 32,
    height: 32,
    borderRadius: 16,
    borderWidth: 2,
    borderColor: '#000000',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    ...Platform.select({
      web: {
        boxShadow: '2px 2px 0px rgba(0,0,0,0.85)',
        cursor: 'pointer',
      },
    }),
  },
  content: {
    marginTop: 16,
    flex: 1,
    height: '100%',
    ...Platform.select({
      web: {
        overflow: 'visible',
      },
    }),
  },
});

export default Modal;

